import { Divider } from '@mui/material'
import { Stack } from '@mui/system'
import { useMinimalsTheme } from '@tom-ui/ui'
import { observer } from 'mobx-react-lite'
import { Fragment } from 'react/jsx-runtime'

import { HoldEntryCard } from '@planning/components/hold/atoms/HoldEntryCard'
import { OrderHoldsSectionStore } from '@planning/components/hold/organisms/stores/OrderHoldsSectionStore'

interface Props {
  store: OrderHoldsSectionStore
  allowAdd?: boolean
}

export const HoldsFormContent = observer(({ store }: Props) => {
  const theme = useMinimalsTheme()

  return (
    <Stack gap={theme.customSpacing.m}>
      {store.holds.value.map((holdStore, idx) => (
        <Fragment key={holdStore.id}>
          {idx > 0 && <Divider sx={{ mb: theme.customSpacing.m }} />}
          <HoldEntryCard
            holdStore={holdStore}
            index={idx}
            onRemove={() => store.removeHold(idx)}
            canRemove={holdStore.backendId === undefined}
          />
        </Fragment>
      ))}
    </Stack>
  )
})
